import { PluginKey } from 'prosemirror-state';

export const suggestedEditsPluginKey = new PluginKey('suggested-edits');
